
import { Button } from "./ui/button";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary text-primary-foreground py-2 px-6 lg:px-8 shadow-md">
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center">
          <Link 
            to="/"
            className="bg-white p-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <img 
              src="/lovable-uploads/quiet-corner-logo.png" 
              alt="Quiet Corner Logo" 
              className="h-10 w-auto"
            />
          </Link>
        </div>

        <div className="hidden lg:flex space-x-8 text-sm">
          <Link to="/book" className="hover:text-accent transition duration-200">Book a Pod</Link>
          <Link to="/#features" className="hover:text-accent transition duration-200">Benefits</Link>
          <Link to="/#how-it-works" className="hover:text-accent transition duration-200">How It Works</Link>
          <Link to="/#booth-specs" className="hover:text-accent transition duration-200">Specifications</Link>
          <Link to="/#experience" className="hover:text-accent transition duration-200">Experience</Link>
          <Link to="/#founders" className="hover:text-accent transition duration-200">Team</Link>
          <Link to="/#contact" className="hover:text-accent transition duration-200">Contact</Link>
        </div>

        <div className="hidden lg:block">
          <Button 
            asChild
            className="bg-accent hover:bg-accent/80 text-accent-foreground font-medium transition-colors duration-300"
          >
            <Link to="/#contact">Get In Touch</Link>
          </Button>
        </div>

        <div className="lg:hidden">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-primary-foreground"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden absolute top-16 left-0 right-0 bg-primary p-4 flex flex-col space-y-4 shadow-lg">
          <Link 
            to="/book" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Book a Pod
          </Link>
          <Link 
            to="/#features" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Benefits
          </Link>
          <Link 
            to="/#how-it-works" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            How It Works
          </Link>
          <Link 
            to="/#booth-specs" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Specifications
          </Link>
          <Link 
            to="/#experience" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Experience
          </Link>
          <Link 
            to="/#founders" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Team
          </Link>
          <Link 
            to="/#contact" 
            className="text-primary-foreground hover:text-accent py-2 px-4"
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
          <Button 
            asChild
            className="bg-accent hover:bg-accent/80 text-accent-foreground w-full transition-colors duration-300"
          >
            <Link to="/#contact" onClick={() => setIsMenuOpen(false)}>
              Get In Touch
            </Link>
          </Button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
